/**
 * Speelveld-/scène-achtergrond per chakra: getinte radiale gradient +
 * twee traag tegengesteld roterende bloembladringen (SVG, n = bloemblaadjes uit
 * de header) + mandala-textuur. Reduced-motion zet de rotatie uit.
 */
import type { Origin } from '../../data/types';
import { HEADERS } from '../../data/headers';

export function BloembladRing({ aantal, kleur, straal = 46 }: { aantal: number; kleur: string; straal?: number }) {
  const blad = Math.min(aantal, 32);
  return (
    <svg viewBox="-50 -50 100 100" className="h-full w-full">
      {Array.from({ length: blad }, (_, i) => {
        const a = (i / blad) * 360;
        return (
          <ellipse
            key={i}
            cx={0}
            cy={-straal * 0.62}
            rx={straal * 0.085}
            ry={straal * 0.34}
            fill={kleur}
            opacity={0.5}
            transform={`rotate(${a})`}
          />
        );
      })}
      <circle cx={0} cy={0} r={straal * 0.16} fill="none" stroke={kleur} strokeWidth={0.8} opacity={0.6} />
    </svg>
  );
}

export function ChakraAchtergrond({ chakra, children }: { chakra: Origin; children?: React.ReactNode }) {
  const h = HEADERS[chakra];
  return (
    <div className="relative h-full w-full overflow-hidden" style={{ background: `radial-gradient(circle at 50% 30%, ${h.kleur}26, #0a0a0f 62%)` }}>
      {/* roterende bloembladringen, gecentreerd, achter de inhoud */}
      <div className="pointer-events-none absolute left-1/2 top-1/2 -z-0 -translate-x-1/2 -translate-y-1/2" style={{ width: '120vmin', height: '120vmin', opacity: 0.12 }}>
        <div className="ca-draai absolute inset-0"><BloembladRing aantal={h.bloemblaadjes} kleur={h.accent} /></div>
        <div className="ca-draai-omgekeerd absolute inset-[18%]"><BloembladRing aantal={Math.max(4, Math.round(h.bloemblaadjes / 2))} kleur={h.kleur} /></div>
      </div>
      <div className="mandala-textuur relative z-10 h-full w-full">{children}</div>
    </div>
  );
}
